// extracted by mini-css-extract-plugin
module.exports = {"sectionLanding":"student-module--section-landing--3UbR2","app":"student-module--app--3GYC_","chest":"student-module--chest--1Bk8U"};